<template>
  <div>
    <el-menu
      router
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
    >
      <el-menu-item index="/mpIndex/miniPro">
        <i class="el-icon-s-custom"></i>
        <span slot="title">小程序管理</span>
      </el-menu-item>
      <el-submenu index="1">
        <span slot="title">
          <i class="el-icon-truck"></i>
          <span>首页管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/mpIndex/colorCard">
            <i class="el-icon-bottom"></i>
            <span slot="title">轮播图</span>
          </el-menu-item>
          <el-menu-item index="/mpIndex/cardItem">
            <i class="el-icon-top"></i>
            <span slot="title">企业合作</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/customer">
        <i class="el-icon-s-custom"></i>
        <span slot="title">用户管理</span>
      </el-menu-item>
      <el-submenu index="4">
        <span slot="title">
          <i class="el-icon-truck"></i>
          <span>色卡管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/mpIndex/colorCard">
            <i class="el-icon-bottom"></i>
            <span slot="title">色卡</span>
          </el-menu-item>
          <el-menu-item index="/mpIndex/cardItem">
            <i class="el-icon-top"></i>
            <span slot="title">色号</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="5">
        <span slot="title">
          <i class="el-icon-goods"></i>
          <span>商品管理</span>
        </span>
        <el-menu-item-group>
          <el-menu-item index="/mpIndex/colorCard">
            <i class="el-icon-menu"></i>
            <span slot="title">商品分类</span>
          </el-menu-item>
          <el-menu-item index="/mpIndex/cardItem">
            <i class="el-icon-ice-cream"></i>
            <span slot="title">商品信息</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="5">
        <i class="el-icon-setting"></i>
        <span slot="title">库存管理</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<style scoped>
/* #sideNav .el-menu-item{
        text-align:left
    } */
</style>
